// extracted by mini-css-extract-plugin
export default {"content":"ModalEditarTarifa_content__W54fH","input":"ModalEditarTarifa_input__pZnSg"};